<app-pageheader class="pageheader" [pageTitle]="'Instances'" [instanceTools]="true"
    [breadCrumbs]="this.breadCrumbItems">
</app-pageheader>
<div class="idn-acc-wrapper">
    <mat-card class="idn-acc-list-card">
        <mat-card-header class="card-header">
            <mat-card-title class="card-title">Instance Details</mat-card-title>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="idn-view-body">
            <div class="card-content">
                <div class="idn-view-body-items">
                    <div class="idn-view-body-items-label">
                        CUSTOMER NAME
                    </div>
                    <div class="idn-view-body-items-data">{{ViewData.customerName}}</div>
                </div>
                <div class="idn-view-body-items">
                    <div class="idn-view-body-items-label">
                        CNAME</div>
                    <div class="idn-view-body-items-data">{{ViewData.cname}}</div>
                </div>

                <div class="idn-view-body-items">
                    <div class="idn-view-body-items-label">
                        INSTANCE TYPE</div>
                    <div class="idn-view-body-items-data">{{ViewData.instanceType}}</div>
                </div>
                
                <div class="idn-view-body-items">
                    <div class="idn-view-body-items-label">
                        ICI VERSION</div>
                    <div class="idn-view-body-items-data">{{ViewData?.iciVersion}}</div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card class="idn-acc-list-card-1" >
        <mat-card-content class="card-content">
            <mat-icon>info</mat-icon>
            <div class="action-description">{{instanceEnum.instance_view_application_log_desc}} <b>History</b> {{instanceEnum.instance_view_history_button_text}}</div>
        </mat-card-content>
    </mat-card>
</div>
<div class="page-container">
    <h2 class="tool-header">Application Logs</h2>
    <div class="ici-panel">
        <div class="ici-left-panel" >
            <!-- <mat-form-field class="pss-block-form">
                <mat-label>Select Type</mat-label>
                <mat-select matNativeControl (selectionChange)="logTypeChange($event)" required>
                    <mat-option value="0"> logs </mat-option>
                    <mat-option value="1"> Traces </mat-option>
                </mat-select>
            </mat-form-field> -->
            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_start_datetime}}</mat-label>
                <input id="appStartDate" [(ngModel)]="getStartValueappLog" [min]="minAppStartDate"
                    [max]="maxAppStartDate" matInput type="datetime-local"
                    (ngModelChange)="applicationStartDateValueChange($event)" required
                    (change)="validateApplicationLogDates($event.target)">
            </mat-form-field>
            <mat-error *ngIf="startDateError">{{startDateErrorMsg}}</mat-error>
    
            <mat-form-field class="pss-block-form">
                <mat-label>{{instanceEnum.instance_view_application_log_end_datetime}}</mat-label>
                <input id="appEndDate" [(ngModel)]="getEndValueappLog" matInput type="datetime-local"
                    [min]="setApplicationMinEndDate" [max]="maxAppEndDate"
                     required
                    (change)="validateApplicationLogDates($event.target)" [disabled]="startDateError">
            </mat-form-field>
            <mat-error *ngIf="endDateError">{{endDateErrorMsg}}</mat-error>
    
            <!-- <mat-form-field class="pss-block-form">
                <mat-label>Trace Id</mat-label>
                <input matInput [(ngModel)]="getTraceId" (change)="validateConfirm($event.target)">
            </mat-form-field>
            <mat-error *ngIf="traceIdError"></mat-error> -->
            <mat-form-field  class="pss-block-form">
                <mat-label>Level</mat-label>
                <mat-select matNativeControl #levelData (selectionChange)="levelChange($event)" required>               
                  <mat-option *ngFor="let level of levelList" [value]="level">
                    {{level}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="pss-block-form">
                <mat-label>Search</mat-label>
                <input matInput [(ngModel)]="getSearchValueappLog">
            </mat-form-field>
            
        </div>
        <div class="ici-right-panel">          
            <mat-form-field class="pss-block-form">
                <mat-label>Context User Id</mat-label>
                <input matInput [(ngModel)]="getContextUserId">
            </mat-form-field>
    
            <mat-form-field class="pss-block-form">
                <mat-label>Context Instance Entity Name</mat-label>
                <input matInput [(ngModel)]="getContextInstanceEntityName">
            </mat-form-field>

            <mat-form-field class="pss-block-form">
                <mat-label>Context Instance Id</mat-label>
                <input matInput [(ngModel)]="getContextInstanceId">
            </mat-form-field>
        </div>
    </div>

    <div class="pss-form-button-wrapper">
        <button mat-flat-button color="primary" [disabled]="validateConfirmAction"
            (click)="onConfirm()">Confirm Action</button>
        <button mat-stroked-button
            (click)="onCancel()">{{instanceEnum.instance_tools_cancel_button}}</button>
    </div>
    
</div>